module.exports = __webpack_public_path__ + "img/5.ec418988.jpg";